import {getErrorByName} from "./Middleware.Helper";
import * as yup from "yup";

export const JobRequisitionRequirementsHelper = (validationRes) => {
  const nonBudgetedRequirements = validationRes?.["non_budgeted_requisition"];

  return {
    nonBudgetedReq: {
      categoryUUID: {
        isRequired: nonBudgetedRequirements?.category_uuid === "required",
        isHidden: nonBudgetedRequirements?.category_uuid === "disable",
      },
      subCategoryUUID: {
        isRequired: nonBudgetedRequirements?.sub_category_uuid === "required",
        isHidden: nonBudgetedRequirements?.sub_category_uuid === "disable",
      },
      priorityUUID: {
        isRequired: nonBudgetedRequirements?.priority_uuid === "required",
        isHidden: nonBudgetedRequirements?.priority_uuid === "disable",
      },
      comment: {
        isRequired: nonBudgetedRequirements?.comment === "required",
        isHidden: nonBudgetedRequirements?.comment === "disable",
      },
      jobTargetUUID: {
        isRequired: nonBudgetedRequirements?.job_target_uuid === "required",
        isHidden: nonBudgetedRequirements?.job_target_uuid === "disable",
      },
      attachment: {
        isRequired: nonBudgetedRequirements?.attachment === "required",
        isHidden: nonBudgetedRequirements?.attachment === "disable",
      },
      project: {
        isRequired: nonBudgetedRequirements?.project === "required",
        isHidden: nonBudgetedRequirements?.project === "disable",
      },
      hierarchyUUID: {
        isRequired: nonBudgetedRequirements?.hierarchy_uuid === "required",
        isHidden: nonBudgetedRequirements?.hierarchy_uuid === "disable",
      },
      qualifications: {
        isRequired: nonBudgetedRequirements?.qualifications === "required",
        isHidden: nonBudgetedRequirements?.qualifications === "disable",
      },
      yearsOfExperience: {
        isRequired: nonBudgetedRequirements?.years_of_experience === "required",
        isHidden: nonBudgetedRequirements?.years_of_experience === "disable",
      },
      noOfOpenings: {
        isRequired: nonBudgetedRequirements?.no_of_openings === "required",
        isHidden: nonBudgetedRequirements?.no_of_openings === "disable",
      },
      jobTypeUUID: {
        isRequired: nonBudgetedRequirements?.job_type_uuid === "required",
        isHidden: nonBudgetedRequirements?.job_type_uuid === "disable",
      },
      joiningDate: {
        isRequired: nonBudgetedRequirements?.joining_date === "required",
        isHidden: nonBudgetedRequirements?.joining_date === "disable",
      },
      location: {
        isRequired: nonBudgetedRequirements?.location === "required",
        isHidden: nonBudgetedRequirements?.location === "disable",
      },
      nationality: {
        isRequired: nonBudgetedRequirements?.nationality === "required",
        isHidden: nonBudgetedRequirements?.nationality === "disable",
      },
      reason: {
        isRequired: nonBudgetedRequirements?.reason === "required",
        isHidden: nonBudgetedRequirements?.reason === "disable",
      },

      description: {
        isRequired: nonBudgetedRequirements?.description === "required",
        isHidden: nonBudgetedRequirements?.description === "disable",
      },
      requirements: {
        isRequired: nonBudgetedRequirements?.requirements === "required",
        isHidden: nonBudgetedRequirements?.requirements === "disable",
      },
      skills: {
        isRequired: nonBudgetedRequirements?.skills === "required",
        isHidden: nonBudgetedRequirements?.skills === "disable",
      },
      positionTitleUUID: {
        isRequired: nonBudgetedRequirements?.position_title_uuid === "required",
        isHidden: nonBudgetedRequirements?.position_title_uuid === "disable",
      },
      salaryRange: {
        isRequired: nonBudgetedRequirements?.salary_range === "required",
        isHidden: nonBudgetedRequirements?.salary_range === "disable",
      },
      jobDescriptionAttachment: {
        isRequired:
          nonBudgetedRequirements?.job_description_attachment === "required",
        isHidden:
          nonBudgetedRequirements?.job_description_attachment === "disable",
      },
      positionUUID: {
        isRequired: nonBudgetedRequirements?.position_uuid === "required",
        isHidden: nonBudgetedRequirements?.position_uuid === "disable",
      },
      jobTitleUUID: {
        isRequired: nonBudgetedRequirements?.job_title_uuid === "required",
        isHidden: nonBudgetedRequirements?.job_title_uuid === "disable",
      },
      positionTitleFreeText: {
        isRequired: nonBudgetedRequirements?.position_title_text === "required",
        isHidden: nonBudgetedRequirements?.position_title_text === "disable",
      },
      jobGradeUUID: {
        isRequired: nonBudgetedRequirements?.job_grade_uuid === "required",
        isHidden: nonBudgetedRequirements?.job_grade_uuid === "disable",
      },
      candidate_id: {
        isRequired: nonBudgetedRequirements?.candidate_id === "required",
        isHidden: nonBudgetedRequirements?.candidate_id === "disable",
      },
      replacement_for: {
        isRequired: nonBudgetedRequirements?.replacement_for === "required",
        isHidden: nonBudgetedRequirements?.replacement_for === "disable",
      },
      total_salary: {
        isRequired: nonBudgetedRequirements?.total_salary === "required",
        isHidden: nonBudgetedRequirements?.total_salary === "disable",
      },
      medical_insurance: {
        isRequired: nonBudgetedRequirements?.medical_insurance === "required",
        isHidden: nonBudgetedRequirements?.medical_insurance === "disable",
      },
      employee_uuid: {
        isRequired: nonBudgetedRequirements?.employee_uuid === "required",
        isHidden: nonBudgetedRequirements?.employee_uuid === "disable",
      },
      reason_for_hiring_uuid: {
        isRequired: nonBudgetedRequirements?.reason_for_hiring_uuid === "required",
        isHidden: nonBudgetedRequirements?.reason_for_hiring_uuid === "disable",
      },
      expense_category_uuid: {
        isRequired: nonBudgetedRequirements?.expense_category_uuid === "required",
        isHidden: nonBudgetedRequirements?.expense_category_uuid === "disable",
      },
    },
  };
};
export const JobRequisitionValidationHelper = ({
  state,
  setErrors,
  requirements,
  t,
}) => {
  getErrorByName(
    {
      current: yup
        .object()
        .shape({
          job_target_uuid: yup
            .string()
            .nullable()
            .test(
              "is-required",
              t("this-field-is-required"),
              (value) =>
                value ||
                !requirements?.nonBudgetedReq?.jobTargetUUID?.isRequired
            ),
          // .required(t("this-field-is-required"))
          position_title_uuid: yup
            .string()
            .nullable()
            .test(
              "is-required",
              t("this-field-is-required"),
              (value) =>
                value ||
                !requirements?.nonBudgetedReq?.positionTitleUUID?.isRequired
            ),
          priority_uuid: yup
            .string()
            .nullable()
            .test(
              "is-required",
              t("this-field-is-required"),
              (value) =>
                value || !requirements?.nonBudgetedReq?.priorityUUID?.isRequired
            ),
          // cv_media_uuid: yup.array().nullable(),
          // recommended_candidate_url: yup
          //   .string()
          //   .nullable()
          //   .matches(urlExpression, {
          //     message: t("invalid-external-url"),
          //     excludeEmptyString: true,
          //   }),attachment_uuid
          attachment: yup
            .array()
            .nullable()
            .test(
              "is-required",
              t("this-field-is-required"),
              (value) =>
                value.length > 0 ||
                !requirements?.nonBudgetedReq?.attachment?.isRequired
            ),
          category_uuid: yup
            .string()
            .nullable()
            .test(
              "is-required",
              t("this-field-is-required"),
              (value) =>
                value || !requirements?.nonBudgetedReq?.categoryUUID?.isRequired
            ),
          comment: yup
            .string()
            .nullable()
            .max(5000, t("please-enter-less-than-5000"))
            .test(
              "is-required",
              t("this-field-is-required"),
              (value) =>
                value || !requirements?.nonBudgetedReq?.comment?.isRequired
            ),
          extra_info: yup.object().shape({
            sub_category_uuid: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value || !requirements?.nonBudgetedReq?.subCategoryUUID?.isRequired
              ),
            reason: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value || !requirements?.nonBudgetedReq?.reason?.isRequired
              ),
            reason_for_hiring_uuid: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value || !requirements?.nonBudgetedReq?.reason_for_hiring_uuid?.isRequired
              ),
            expense_category_uuid: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value || !requirements?.nonBudgetedReq?.expense_category_uuid?.isRequired
              ),
            project: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value || !requirements?.nonBudgetedReq?.project?.isRequired
              ),
            position_uuid: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.positionUUID?.isRequired
              ),
            job_title_uuid: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.jobTitleUUID?.isRequired
              ),
            location: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value || !requirements?.nonBudgetedReq?.location?.isRequired
              ),
            years_of_experience: yup
              .number()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.yearsOfExperience?.isRequired
              ),
            no_of_openings: yup
              .number()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.noOfOpenings?.isRequired
              ),
            hierarchy_uuid: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.hierarchyUUID?.isRequired
              ),
            salary_range: yup
              .object()
              .nullable()
              .shape({
                from: yup
                  .string()
                  .nullable()
                  .test(
                    "is-required",
                    t("this-field-is-required"),
                    (value) =>
                      value ||
                      !requirements?.nonBudgetedReq?.salaryRange?.isRequired
                  ),
                to: yup
                  .string()
                  .nullable()
                  .test(
                    "is-required",
                    t("this-field-is-required"),
                    (value) =>
                      value ||
                      !requirements?.nonBudgetedReq?.salaryRange?.isRequired
                  ),
              }),
            job_description_attachment: yup
              .array()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.jobDescriptionAttachment
                    ?.isRequired
              ),
            joining_date: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.joiningDate?.isRequired
              ),
            job_type_uuid: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.jobTypeUUID?.isRequired
              ),
            nationality: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.nationality?.isRequired
              ),
            qualifications: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.qualifications?.isRequired
              ),
            requirements: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.requirements?.isRequired
              ),
            description: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.description?.isRequired
              ),
            skills: yup
              .array()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value.length > 0 ||
                  !requirements?.nonBudgetedReq?.skills?.isRequired
              ),
            position_title_text: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.positionTitleFreeText
                    ?.isRequired
              ),
            job_grade_uuid: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.jobGradeUUID?.isRequired
              ),
            employee_uuid: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.employee_uuid?.isRequired
              ),
            replacement_for: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.replacement_for?.isRequired
              ),
            candidate_id: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.candidate_id?.isRequired
              ),
            medical_insurance: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.medical_insurance?.isRequired
              ),
            total_salary: yup
              .string()
              .nullable()
              .test(
                "is-required",
                t("this-field-is-required"),
                (value) =>
                  value ||
                  !requirements?.nonBudgetedReq?.total_salary?.isRequired
              ),
          }),
        })
        .nullable(),
    },
    state
  ).then((result) => {
    setErrors(result);
  });
};
export const BudgetedJobRequisitionValidationHelper = ({
  state,
  setErrors,
  requirements,
  t,
}) => {
  getErrorByName(
    {
      current: yup
        .object()
        .shape({
          attachment: yup
            .array()
            .nullable()
            .test(
              "is-required",
              t("this-field-is-required"),
              (value) =>
                value.length > 0 ||
                !requirements?.budgetedReq?.attachment?.isRequired
            ),
          comment: yup
            .string()
            .nullable()
            .max(5000, t("please-enter-less-than-5000"))
            .test(
              "is-required",
              t("this-field-is-required"),
              (value) =>
                value || !requirements?.budgetedReq?.comment?.isRequired
            ),
          status: yup
            .string()
            .nullable()
            .test(
              "is-required",
              t("this-field-is-required"),
              (value) =>
                value || !requirements?.budgetedReq?.status?.isRequired
            ),
        })
        .nullable(),
    },
    state
  ).then((result) => {
    setErrors(result);
  });
};
export const BudgetedJobRequisitionRequirementsHelper = (validationRes) => {
  const budgetedRequirements = validationRes?.["budgeted_requisition"];

  return {
    budgetedReq: {
      comment: {
        isRequired: budgetedRequirements?.comment === "required",
        isHidden: budgetedRequirements?.comment === "disable",
      },
      attachment: {
        isRequired: budgetedRequirements?.attachment === "required",
        isHidden: budgetedRequirements?.attachment === "disable",
      },
      status: {
        isRequired: budgetedRequirements?.status === "required",
        isHidden: budgetedRequirements?.status === "disable",
      },
    },
  };
};
